
	import { defineComponent, computed, ref, onBeforeMount, toRefs } from 'vue';
	import { useRoute } from 'vue-router'

	export default defineComponent ({
		name: 'template-content-video',
		props: {
			datum: {
				type: Object,
				required: true,
			}
		},
		setup(props) {
			/**
			 * Endpoint
			 */
			const route = useRoute();
			const endpointId = computed((): string => {
				return route.params.endpointId as string;
			});

			/**
			 * Video
			 */
			const { datum } = toRefs(props);
			const videoSource = ref('');
			const posterSource = ref('');
			const video = ref();

			onBeforeMount(async () => {
				try {
					videoSource.value = require(`@/applications/covid-hub/ui/assets/videos/${endpointId.value}-${datum.value.area}.mp4`);
					posterSource.value = require(`@/applications/covid-hub/ui/assets/videos/${endpointId.value}-${datum.value.area}-poster.png`);
				} catch (err) {
					console.warn(err);
				}
			})

			function onVideoClick () {
				video.value.play();
			}

			return { endpointId, videoSource, posterSource, video, onVideoClick }
		}
	})
